import * as React from 'react';
import styled from "styled-components"
import BoxDesign from '../reports/BoxDesign';
import log from '../images/LuxinHotel.png';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
//import TableHead from '@mui/material/TableHead';




const PrintStyle = styled.div`-direction-print-right: 0;
  --direction-print-left: 1;
  --ad-prime-1: var(--n-grey-1);
  --main-color: var(--n-grey-2);
  font-family: var(--font-en) !important;
  * {
    font-family: var(--font-en) !important;
  }
  /* direction: rtl; */
  &.agency {
    --main-color: #6C648B;
    --ad-prime-1: #6C648B20;
  }
  &.broker {
    --main-color: #FEA202;
    --ad-prime-1: #FEA20220;
  }
  &.rtl {
    direction: ltr;
    font-family: var(--font-fa) !important;
    * {
      font-family: var(--font-fa) !important;
    }
    --direction-print-right: 0;
    --direction-print-left: 1;
  }
  @page {
    size: portrait;
}
.print-footer {
  position: fixed;
  bottom: 0;
}
  .print-header {
    margin: 0 0 2rem;
    width: 100%;
    height:150px;
    display: flex;
    flex-wrap: wrap;
    gap: 0.7rem;
    align-items: center;
    font-size: 1.2rem;
    .header-row {
     // width: calc(100% - 2rem);
      padding: 1rem;
      font-weight: 700;
    }
    .expand {
      flex-grow: 1;
    }
    .image {
      width: 80px;
      height: 80px;
      border-radius: 200px;
      border: 1px solid var(--n-grey-2);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    .dates {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      .date {
        display: flex;
        justify-content: space-between;
        gap: 0.5rem;
      }
    }
  }
`



export default function HotelInvoice_Print(props) {
  let today = new Date();
  return (
     <div style={{ border: 'solid' }}>
    <PrintStyle>
     
        <BoxDesign className={"print-header"}>
          <div style={{ marginLeft: '20px' }} >
            {/* <label style={{ color: 'white', fontSize: '36px', fontFamily: 'Times-Roman' }}>  Luxin Hotel </label> */}
            {/* <img src={log} alt="farazandishan" /> */}
          </div>

          <div style={{ borderColor:'gray',border:'solid',borderRadius:'10px', marginRight: 'auto', marginLeft: '20px', backgroundColor: 'gray', width: '300px', height: '50px' }} >
            <div>
              <label style={{ fontSize: '26px', color: 'white', fontFamily: 'math !important' }}>  Luxin Hotel </label>

            </div>
            <div style={{fontWeight:'bold', textAlign: 'left', marginTop: '30px', fontSize: '16px', fontFamily: 'math !important' }}>
              Invoice
            </div>

          </div>
          <div className='row' style={{ display: 'inherit', marginRight: '50px' }}>
            <img src={log} alt="farazandishan" />
          </div>

        </BoxDesign>

        <BoxDesign className={"top-box"} style={{ fontWeight: 'bold', fontSize: '12px', height: '80px', marginLeft: '20px' }}>
          <div className={'filters'} style={{ textAlign: 'left' }}>
            No:00001

            <div className={'top-box'} style={{ marginRight: '400px',float:'right' ,display:'inherit'}} >

              Date:{today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()}
            </div>
          </div>
          <div className={'top-box'} style={{ textAlign: 'left',marginTop:'20px' }}>

            Addres: 12-4 konstantin Eristavi Dead end , Tbilisi
            <div style={{ textAlign: 'right',marginRight:'20px', position: 'inherit', float: 'right' }} >

              Tel: +995511225552
            </div>
          </div>



        </BoxDesign>
        <BoxDesign className={"top-box"} style={{ height: '140px' }}>
          <div className='rowleft' style={{ marginLeft: '-40px' }}>
            <div className='filter-title' style={{ display: 'flex', marginLeft: '50px' }}>

              <TableContainer component={Table}  >
                <Table size='small' >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px', width: '650px' }} >Passenger Name:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px', width: '650px' }}>{props.FName + "  " + props.LName}</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px', width: '650px' }} >Check In:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px', width: '650px' }}> {props.Checkindate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px', width: '150px' }}>Room No:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}>{props.Room_Number}</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer component={Table} style={{ marginLeft: '100px' }}  >
                <Table size='small'  >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px' }} >Pass No:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}> {props.Pass_No}</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px' }}>Check Out: </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}>{props.Checkoutdate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '12px' }}>Number of Passenger:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '12px' }}>{props.Adults_No}</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </BoxDesign>
        <div style={{ border: 'solid', marginLeft: '10px', marginRight: '10px',marginTop:'20px',height:'400px' }}>
          <div className='title' style={{marginTop:'20px', borderColor:'gray',border:'solid', fontWeight: 'bold', fontSize: '12px', alignContent: 'center', alignItems: 'center', display: 'inherit',marginRight:'10px', marginLeft: '20px', width: 'auto', height: '30px', backgroundColor: '#F2F2F2F2' }}>
            <div style={{ marginLeft: '20px', display: 'inherit', float: 'left' }}>

              No Night: {props.Night_No}

            </div>
            <div style={{ marginLeft: '150px', display: 'inherit', float: 'left' }}>
              Fee:95
            </div>
            <div style={{ marginLeft: '170px', display: 'inherit', float: 'left' }}>
              Currency: GEL
            </div>
            <div style={{ marginLeft: '200px' }}>
              Total:
              <div style={{ float: 'right', marginRight: '20px' }}>
                {665}
                {/* {props.Reserv_Price} */}
              </div>
            </div>
          </div>

          <BoxDesign className={"top-box"} style={{ display: 'flex' ,height:'200px'}}>
            <div style={{ marginLeft: '20px', position: 'inherit', float: 'left', marginTop: '20px', textAlign: 'left', width: '900px', height: '240px', fontSize: '16px', fontWeight: 'bold' }}>
              Other Cost:
            </div>
            <div style={{borderColor:'gray',border:'solid',borderRadius:'10px', marginTop: '20px', marginLeft: '50px', marginRight: '10px', position: 'inherit', float: 'right', alignContent: 'center', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2' }}>
              Extra Bed :
              <div style={{ float: 'right', marginRight: '20px' }}>
                {props.Reserv_Extrabed}
              </div>

              <div style={{borderColor:'gray',border:'solid',borderRadius:'10px', marginTop: '25px', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2' }}>
                Restaurant  :
                <div style={{ float: 'right', marginRight: '20px' }}>
                  {props.Rest_Sum}
                </div>
              </div>
              <div style={{ borderColor:'gray',border:'solid',borderRadius:'10px',marginTop: '5px', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2' }}>
                Breakfast  :
                <div style={{ float: 'right', marginRight: '20px' }}>
                  {props.Reserv_Breakfast}
                </div>

              </div>
              <div style={{ borderColor:'gray',border:'solid',borderRadius:'10px',marginTop: '5px', textAlign: 'left', width: '210px', height: '30px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#F2F2F2', display: 'flex' }}>
                Other  :
                <div  >

                </div>

              </div>
            </div>

          </BoxDesign>

          <div className='title' style={{borderColor:'gray',border:'solid',  fontWeight: 'bold', fontSize: '12px', alignContent: 'center', alignItems: 'center', display: 'inherit',marginRight:'10px', marginLeft: '20px', width: 'auto', height: '30px', backgroundColor: '#F2F2F2F2' }}>
            <div style={{ marginLeft: '20px', display: 'inherit', float: 'left' }}>
              SUM:
            </div>
            <div style={{ display: 'inherit', float: 'right', marginRight: '20px' }}>
              {665}
              {/* {props.Rest_Sum} */}
            </div>


          </div>

          <BoxDesign className={"top-box"} style={{ borderColor:'gray',border:'solid',borderRadius:'10px', float: 'right',marginTop:'7px',marginRight:'10px', display: 'inherits' }}>

            <div className='title' style={{ textAlign: 'left', fontWeight:'bold', fontSize: '12px', alignContent: 'center', width: '210px', height: '30px', backgroundColor: '#F2F2F2F2' }} >
              Advance Payment         :
              <div style={{ display: 'inherit', float: 'right', marginRight: '20px' }}>

                {props.Rest_Sum}
              </div>
            </div>
          </BoxDesign>

          {/* <div className='title' style={{ alignItems: 'center', marginLeft: '20px', width: 'auto', height: '50px', backgroundColor: '#F2F2F2F2', border: 'solid' }}> */}
          <div className='title' style={{borderColor:'gray',border:'solid', marginTop: '50px', fontWeight: 'bold', fontSize: '12px', alignContent: 'center', alignItems: 'center', display: 'inherit',marginRight:'10px', marginLeft: '20px', width: 'auto', height: '30px', backgroundColor: '#F2F2F2F2' }}>
            <div style={{ marginLeft: '20px', display: 'inherit', float: 'left' }}>

              Balance Payable:
            </div>
            <div style={{ display: 'inherit', float: 'right', marginRight: '20px' }}>
            {665}
              {/* {props.Balance} */}
            </div>

          </div>
          
        </div>
        <br>
        </br>
        <br></br>
        {/* <BoxDesign className={"top-box"}> */}

        <div className='title' style={{  fontSize: '14px', fontWeight: 'bold', textAlign: 'left' , marginLeft: '20px'}} >
            Thank you for your warm presence . We hope to see you again.
          
          </div>
          <br>
        </br>
        <br></br>
          <div className='title' style={{ display:'flex', fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }} >
            Manager Hotel.
          </div>
        {/* </BoxDesign> */}

        <br>
        </br>
        <br></br>
        <br></br>
        <br></br>
    </PrintStyle>
  </div>

  )
}